/* OJ Nav cards - the arrows on the picture row in the mega menu.
   See "The picture row as a carousel" in oj-nav-cards.css. Each arrow
   pages by as many whole cards as fit, and shows only when there is more
   in its direction. The row has no size while its menu is closed, so a
   ResizeObserver re-checks the arrows when the menu opens. */
(function () {
  function setup(viewport) {
    if (viewport.ojNavSlider) return;
    viewport.ojNavSlider = true;

    var row = viewport.querySelector('.oj-navcards__row');
    var prev = viewport.querySelector('[data-oj-nc-prev]');
    var next = viewport.querySelector('[data-oj-nc-next]');
    if (!row || !prev || !next) return;

    function step() {
      var item = row.querySelector('.oj-navcards__item');
      if (!item) return row.clientWidth;
      var gap = parseFloat(getComputedStyle(row).columnGap) || 0;
      var width = item.getBoundingClientRect().width + gap;
      var perView = Math.max(1, Math.round((row.clientWidth + gap) / width));
      return width * perView;
    }

    function update() {
      var max = row.scrollWidth - row.clientWidth;
      prev.hidden = row.scrollLeft <= 2;
      next.hidden = max <= 2 || row.scrollLeft >= max - 2;
    }

    prev.addEventListener('click', function () { row.scrollBy({ left: -step() }); });
    next.addEventListener('click', function () { row.scrollBy({ left: step() }); });
    row.addEventListener('scroll', update, { passive: true });
    if (window.ResizeObserver) new ResizeObserver(update).observe(row);
    update();
  }

  function init() {
    document.querySelectorAll('[data-oj-nc-slider]').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
